<script setup lang="ts">
const btns = ref()
const props = defineProps({
  sections: {
    type: Array as PropType<{ title: string; icon: Component }[]>,
    required: true
  },
  active: {
    type: Number,
    required: true
  },
  enrolmentOpen: {
    type: Boolean,
    required: true
  },
  buttonTitle: {
    type: String,
    required: true,
    default: 'Apply now'
  }
})

const emit = defineEmits(['scrollTo', 'clickBrochure', 'clickApply'])
const { scrollToTab } = useScroll()

const scrollTo = (index: number) => {
  // bar scrolling to bar button
  const container = btns.value.children[0]
  scrollToTab(btns.value, container, index)

  // scroll to section
  emit('scrollTo', index)
}

const getBtnClass = (index: number) => {
  const btnClass = 'course-btn clickable '

  return props.active === index ? btnClass + 'active' : btnClass
}
</script>

<template>
  <aside ref="btns" class="hide-scrollbar">
    <div id="course-item-btns">
      <div
        v-for="(section, index) in sections"
        :key="section.title"
        :class="getBtnClass(index)"
        @click="scrollTo(index)"
      >
        <component :is="section.icon" />
        {{ section.title }}
      </div>
    </div>

    <div id="course-item-apply">
      <CommonButton
        v-if="enrolmentOpen"
        outline
        :disabled="!enrolmentOpen"
        @handle-click="$emit('clickApply')"
      >
        Start learning
      </CommonButton>

      <!-- <CommonButton :arrow="true" :outline="true" @click="$emit('clickBrochure')">
        Get brochure
      </CommonButton> -->
    </div>
  </aside>
</template>

<style scoped lang="scss">
$purple: #f6ebff;

#course-item {
  aside {
    position: sticky;
    top: calc(var(--navbarHeight) + 20px);
    left: 0;
    background-color: white;
  }

  &-btns {
    padding-top: 20px;
    border-top: 1px solid var(--borderLight);
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 220px;

    .course-btn {
      padding: 15px 25px;
      border-radius: 10px;
      font-size: 0.95rem;
      font-weight: 500;
      display: flex;
      align-items: center;

      svg {
        $size: 17px;
        height: $size;
        width: $size;
        margin-right: 20px;
        fill: var(--black);
      }
    }

    .active {
      background-color: $purple;
      color: var(--darkPurple);

      svg {
        fill: var(--darkPurple);
      }
    }
  }

  &-apply {
    margin-top: 35px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    :deep(.btn-m) {
      font-size: 0.95rem;
    }
  }
}

@media (max-width: 900px) {
  #course-item {
    aside {
      display: flex;
      top: var(--navbarHeight);
      width: 100vw;
      margin-left: -20px;
      background-color: white;
      z-index: 20;
      border-bottom: 1px solid var(--borderLight);
      padding: 0 20px;
      overflow-x: scroll;
      align-items: flex-end;
    }

    &-btns {
      padding: 0;
      flex: 1;
      border-top: 0;
      flex-direction: row;
      width: auto;
      align-items: center;
      gap: 7px;
      position: relative;

      .course-btn {
        background-color: white;
        padding: 22px 17px 15px;
        height: auto;
        border-radius: 0;
        border-bottom: 3px solid transparent;
        position: relative;
        font-size: 0.9rem;
        color: var(--textLight);

        svg {
          $size: 14px;
          height: $size;
          width: $size;
          margin-right: 12px;
          fill: var(--textLight);
        }
      }

      .active {
        border-color: var(--purple);
        color: var(--purple);

        svg {
          fill: var(--purple);
        }
      }
    }

    &-apply {
      margin: 0;
      margin-left: 25px;
      height: auto;
      display: block;
      position: relative;
      padding-bottom: 10px;

      :deep(.btn-m) {
        padding: 8px 17px 8px 22px;
        margin: 0;
        white-space: nowrap;
        position: relative;
        display: flex;
        align-items: center;
        font-size: 0.87rem;
      }

      /* :deep(.btn-arrow:last-of-type) {
        display: none;
      } */
    }
  }
}

@media (hover: hover) {
  #course-item {
    &-btns {
      .course-btn:hover {
        background-color: #fbf6ff;
      }

      .active:hover {
        background-color: $purple;
      }
    }
  }
}
</style>
